import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Group } from '@mantine/core';
import { Link } from 'gatsby';

import { googleAnalyticsWrapper } from '@landing_academy/shared';

import { AppContext } from '../provider';
import * as classes from './ButtonBlock.module.css';


function ButtonBlock({ buttons }) {
  const parsedButtons = useMemo(() => (buttons || []).map((b) => ({
    ...b, style: JSON.parse(b.style)
  })), [buttons]);

  if (!parsedButtons.length) {
    return null;
  }

  return (
    <AppContext.Consumer>
      {({ setter }) => (
        <Group mt={30} className={classes.group}>
          {parsedButtons.map(({
            buttonHref,
            buttonLabel,
            buttonFunction,
            googleAnalyticsEventPayload,
            style,
          }, key) => {
            const props = {};

            if (buttonFunction && buttonFunction === 'apriFormContatto') {
              props.onClick = () => setter({ formContattoOpened: true });
            }

            if (googleAnalyticsEventPayload) {
              try {
                const event = JSON.parse(googleAnalyticsEventPayload);
                if (event) {
                  if (props.onClick) {
                    const fx = props.onClick;
                    props.onClick = () => {
                      fx();
                      googleAnalyticsWrapper('event', event);
                    };
                  } else {
                    googleAnalyticsWrapper('event', event);
                  }
                }
              } catch (_) { }
            }

            if (buttonHref.startsWith('https://')) {
              props.component = 'a';
              props.target = '_blank';
              props.href = buttonHref;
            } else if (buttonHref) {
              props.component = Link;
              props.to = buttonHref;
            }

            return (
              <Button
                key={`button_${key + 1}`}
                size="md"
                {...props}
                {...style}
                classNames={{ root: classes.buttonRoot }}
              >
                {buttonLabel}
              </Button>
            );
          })}
        </Group>
      )}
    </AppContext.Consumer>
  );
}

ButtonBlock.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      buttonFunction: PropTypes.string,
      buttonLabel: PropTypes.string.isRequired,
      buttonHref: PropTypes.string,
      style: PropTypes.string,
    })
  )
};

export default ButtonBlock;
